import { IconArrowLeft, IconHelp, IconX } from '@tabler/icons-react-native';
import { Pressable, View } from 'react-native';
import { HubProgress, HubTabs, hubColors, styles } from '../components';

import type { OfferHubState } from '../hooks';

export function OfferHubHeader({
  helpTutorialVisible,
  t,
  swiping,
  setActive,
  replayTutorial,
  items,
  round,
  tutorialOverlayVisible,
  tab,
  selectTab,
  canUseAI,
  replaySwipeTutorial,
  close,
}: Pick<
  OfferHubState,
  | 'helpTutorialVisible'
  | 't'
  | 'swiping'
  | 'setActive'
  | 'replayTutorial'
  | 'items'
  | 'round'
  | 'tutorialOverlayVisible'
  | 'tab'
  | 'selectTab'
  | 'canUseAI'
  | 'replaySwipeTutorial'
  | 'close'
>) {
  return (
    <View style={styles.header}>
      {helpTutorialVisible ? (
        <View style={styles.iconButton} />
      ) : (
        <Pressable
          style={styles.iconButton}
          accessibilityRole="button"
          accessibilityLabel={t(swiping ? 'backToHub' : 'help')}
          onPress={() => {
            if (swiping) setActive(false);
            else replayTutorial();
          }}
        >
          {swiping ? <IconArrowLeft size={24} color={hubColors.ink} /> : <IconHelp size={24} color={hubColors.ink} />}
        </Pressable>
      )}
      <View style={styles.headerCenter}>
        {swiping ? (
          <HubProgress remaining={items.length} total={round?.items.length ?? 10} />
        ) : !tutorialOverlayVisible ? (
          <HubTabs selected={tab} onSelect={selectTab} canUseAI={canUseAI} />
        ) : null}
      </View>
      {swiping ? (
        <Pressable
          style={styles.iconButton}
          accessibilityRole="button"
          accessibilityLabel={t('help')}
          onPress={replaySwipeTutorial}
        >
          <IconHelp size={24} color={hubColors.ink} />
        </Pressable>
      ) : (
        <Pressable style={styles.iconButton} accessibilityRole="button" accessibilityLabel={t('close')} onPress={close}>
          <IconX size={24} color={hubColors.ink} />
        </Pressable>
      )}
    </View>
  );
}
